// @ vendors
const Immutable = require('immutable');

// @ constants
const {
    INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_REQUEST,
    INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_SUCCESS,
    INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_FAILURE,
    INSURANCE_REQUEST_SIMULATION_CANCEL_REQUEST,
    INSURANCE_REQUEST_SIMULATION_CANCEL_SUCCESS,
    INSURANCE_REQUEST_SIMULATION_CANCEL_FAILURE,
    INSURANCE_REQUEST_SIMULATION_RESET
} = require('../../insuranceConstants/actionTypes');

const setInitialState = () => Immutable.fromJS({
    id: 0,
    error: '',
    isFetching: false,
    token: '',
    isFetchingCancel: false,
    hasCanceled: false,
    errorCancel: ''
});

const insuranceRequestSimulation = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_REQUEST:
            return state.merge({
                isFetching: true,
                token: action.data.token
            });
        case INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_SUCCESS:
            return state.merge({
                id: action.data.id,
                isFetching: false,
                isFetchingCancel: false,
                error: '',
                errorCancel: '',
                hasCanceled: false,
                token: ''
            });
        case INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_FAILURE:
            return state.merge({
                error: action.data.error,
                isFetching: false
            });
        case INSURANCE_REQUEST_SIMULATION_CANCEL_REQUEST:
            return state.merge({
                isFetchingCancel: true
            });
        case INSURANCE_REQUEST_SIMULATION_CANCEL_SUCCESS:
            return state.merge({
                isFetchingCancel: false,
                hasCanceled: true
            });
        case INSURANCE_REQUEST_SIMULATION_CANCEL_FAILURE:
            return state.merge({
                isFetchingCancel: false,
                errorCancel: action.data.error
            });
        case INSURANCE_REQUEST_SIMULATION_RESET:
            return state.merge({
                isFetching: false,
                isFetchingCancel: false,
                error: '',
                errorCancel: '',
                hasCanceled: false,
                token: ''
            });
        default:
            return state
    }
};

module.exports = insuranceRequestSimulation;
module.exports.setInitialState = setInitialState;
